module.exports = "images/nav-laptops-20171010.jpg";